/* ═══════════════════════════════════════════════════════════
   CLARVE — Theme JavaScript
   ═══════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  // ── MOBILE NAV ─────────────────────────────────────────────
  const toggle = document.querySelector('.nav-mobile-toggle');
  const navLinks = document.querySelector('.nav-links');
  if (toggle && navLinks) {
    toggle.addEventListener('click', () => {
      navLinks.classList.toggle('open');
      const isOpen = navLinks.classList.contains('open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
    document.addEventListener('click', (e) => {
      if (!toggle.contains(e.target) && !navLinks.contains(e.target)) {
        navLinks.classList.remove('open');
      }
    });
  }

  // ── SCIENCE TABS ───────────────────────────────────────────
  const sciTabs = document.querySelectorAll('.sci-tab');
  const sciPanels = document.querySelectorAll('.sci-panel');
  sciTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.panel;
      sciTabs.forEach(t => t.classList.remove('active'));
      sciPanels.forEach(p => p.classList.remove('active'));
      tab.classList.add('active');
      const panel = document.getElementById('sci-' + target);
      if (panel) panel.classList.add('active');
    });
  });

  // ── FAQ ACCORDION ──────────────────────────────────────────
  const faqButtons = document.querySelectorAll('.faq-q');
  faqButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const answer = btn.nextElementSibling;
      const isOpen = answer.classList.contains('open');
      // Close all
      document.querySelectorAll('.faq-a').forEach(a => a.classList.remove('open'));
      document.querySelectorAll('.faq-q').forEach(q => q.setAttribute('aria-expanded', 'false'));
      // Open clicked if was closed
      if (!isOpen) {
        answer.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ── SMOOTH SCROLL for nav links ────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const navHeight = document.querySelector('.site-nav') ? document.querySelector('.site-nav').offsetHeight : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - navHeight;
        window.scrollTo({ top, behavior: 'smooth' });
        if (navLinks) navLinks.classList.remove('open');
      }
    });
  });

  // ── ACTIVE NAV HIGHLIGHT on scroll ────────────────────────
  const sections = document.querySelectorAll('section[id], div[id]');
  const navAnchors = document.querySelectorAll('.nav-links a[href^="#"]');
  if (sections.length && navAnchors.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          navAnchors.forEach(a => a.classList.remove('active'));
          const active = document.querySelector(`.nav-links a[href="#${entry.target.id}"]`);
          if (active) active.classList.add('active');
        }
      });
    }, { threshold: 0.3 });
    sections.forEach(s => observer.observe(s));
  }

  // ── HERO PANEL PROTOCOL ROTATOR ───────────────────────────
  const protocolData = document.getElementById('hero-protocols');
  if (protocolData) {
    try {
      const protocols = JSON.parse(protocolData.textContent);
      const content   = document.querySelector('.hero-panel-content');
      const nameEl    = document.querySelector('.hero-panel-name');
      const subEl     = document.querySelector('.hero-panel-sub');
      const rowsEl    = document.querySelector('.hero-panel-rows');
      const ctaEl     = document.querySelector('.hero-panel-cta');

      if (protocols.length > 1 && content && nameEl) {
        let idx = 0;

        function renderProtocol(p) {
          nameEl.textContent = p.name;
          subEl.textContent  = p.sub;
          rowsEl.innerHTML   = p.rows.split('||').map(function(row) {
            const parts = row.split(':::');
            return '<div class="hero-panel-row"><span class="hero-panel-key">' + (parts[0] || '') + '</span><span class="hero-panel-val">' + (parts[1] || '') + '</span></div>';
          }).join('');
          if (ctaEl) {
            ctaEl.textContent = p.cta_label;
            if (p.cta_url) ctaEl.href = p.cta_url;
          }
        }

        setInterval(function() {
          content.classList.add('fading');
          setTimeout(function() {
            idx = (idx + 1) % protocols.length;
            renderProtocol(protocols[idx]);
            content.classList.remove('fading');
          }, 350);
        }, 5000);
      }
    } catch (e) {}
  }

  // ── NEWSLETTER FORM ────────────────────────────────────────
  const ctaForm = document.querySelector('.cta-form');
  if (ctaForm) {
    ctaForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = ctaForm.querySelector('.cta-input');
      const btn = ctaForm.querySelector('.cta-submit');
      if (!input.value || !input.value.includes('@')) {
        input.style.borderColor = '#D4748A';
        setTimeout(() => { input.style.borderColor = ''; }, 2000);
        return;
      }
      btn.textContent = 'Submitted ✓';
      btn.style.background = '#5A9E6F';
      btn.style.color = '#fff';
      input.disabled = true;
      btn.disabled = true;
    });
  }

  // ── CART quantity controls ─────────────────────────────────
  function formatMoney(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    return 'R\u00a0' + (n / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const wrap  = this.closest('.qty-wrap');
      const input = wrap.querySelector('.qty-input');
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'inc') val = Math.min(val + 1, 99);
      if (this.dataset.action === 'dec') val = Math.max(val - 1, 0);
      input.value = val;

      if (!wrap) return;
      const key   = wrap.dataset.key;
      const price = parseInt(wrap.dataset.price) || 0;
      const row   = wrap.closest('tr');

      fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: key, quantity: val })
      })
      .then(r => r.json())
      .then(cart => {
        // update line total
        if (row) {
          const lineCell = row.querySelector('.cart-line-total');
          if (lineCell) lineCell.textContent = formatMoney(price * val);
        }
        // Update the cart total. Target the explicit Total cell so we never
        // overwrite the Subtotal or any discount lines that sit above it.
        // If the response didn't include total_price (eg. a Shopify error),
        // reload the page so the Liquid-rendered total is shown rather than
        // ending up displaying "R NaN".
        const totalEl = document.querySelector('[data-cart-total]') || document.querySelector('.cart-total-val--total') || document.querySelectorAll('.cart-total-val')[document.querySelectorAll('.cart-total-val').length - 1];
        var newTotal = formatMoney(cart && cart.total_price);
        if (totalEl && newTotal) {
          totalEl.textContent = newTotal;
        } else if (totalEl) {
          window.location.reload();
        }
        // remove row if qty is 0
        if (val === 0 && row) row.remove();
      })
      .catch(() => {});
    });
  });

  // ── ANNOUNCEMENT BAR dismiss ──────────────────────────────
  const dismissBtn = document.querySelector('.announcement-dismiss');
  const bar = document.querySelector('.announcement-bar');
  if (dismissBtn && bar) {
    dismissBtn.addEventListener('click', () => {
      bar.style.display = 'none';
      sessionStorage.setItem('clarve_ann_dismissed', '1');
    });
    if (sessionStorage.getItem('clarve_ann_dismissed')) {
      bar.style.display = 'none';
    }
  }

  // ── TRUMD UPSELL ───────────────────────────────────────────
  const upsellToggle = document.getElementById('trumd-upsell-toggle');
  if (upsellToggle) {
    upsellToggle.addEventListener('change', function () {
      const checkbox  = this;
      const wrap      = document.getElementById('trumd-upsell-wrap');
      let   variantId = checkbox.dataset.variant;

      // Disable UI while processing
      checkbox.disabled = true;
      if (wrap) wrap.style.opacity = '0.6';

      const revert = (wasChecked) => {
        checkbox.checked  = wasChecked;
        checkbox.disabled = false;
        if (wrap) wrap.style.opacity = '1';
      };

      const proceed = (vid) => {
        if (checkbox.checked) {
          fetch('/cart/add.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({ id: parseInt(vid), quantity: 1 })
          })
          .then(r => {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(() => { window.location.reload(); })
          .catch(() => { revert(false); });
        } else {
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              const line = cart.items.find(i => String(i.variant_id) === String(vid));
              if (!line) { revert(true); return; }
              return fetch('/cart/change.js', {
                method:  'POST',
                headers: { 'Content-Type': 'application/json' },
                body:    JSON.stringify({ id: line.key, quantity: 0 })
              });
            })
            .then(() => { window.location.reload(); })
            .catch(() => { revert(true); });
        }
      };

      if (variantId && variantId !== '') {
        proceed(variantId);
      } else {
        // Fallback: fetch variant ID from product JSON
        fetch('/products/trumd-monthly-subscription.js')
          .then(r => r.json())
          .then(product => {
            const vid = product.variants && product.variants[0] && product.variants[0].id;
            if (!vid) { revert(!checkbox.checked); return; }
            checkbox.dataset.variant = vid;
            proceed(vid);
          })
          .catch(() => { revert(!checkbox.checked); });
      }
    });
  }

  // ── THERAPY QUIZ ───────────────────────────────────────────
  const quizStage = document.getElementById('quiz-stage');
  if (quizStage) {
    const progressFill  = document.getElementById('quiz-progress-fill');
    const progressLabel = document.getElementById('quiz-progress-label');

    const questions = [
      {
        q: 'What is your primary health goal?',
        key: 'goal',
        answers: [
          { label: 'Recover from injury, surgery, or chronic pain',         value: 'recovery' },
          { label: 'Lose stubborn fat and improve body composition',         value: 'fat'      },
          { label: 'Strengthen or restore my immune system',                 value: 'immune'   },
          { label: 'Improve my skin, reduce ageing, and rebuild collagen',   value: 'skin'     },
          { label: 'Build lean muscle and improve athletic performance',      value: 'muscle'   }
        ]
      },
      {
        q: 'How would you describe your situation?',
        key: 'situation',
        answers: [
          { label: 'It is recent — I want to address it now',                value: 'acute'    },
          { label: 'It has been ongoing for months',                         value: 'chronic'  },
          { label: 'I am generally well but want to optimise',               value: 'optimise' }
        ]
      },
      {
        q: 'What kind of approach suits you best?',
        key: 'approach',
        answers: [
          { label: 'A single targeted therapy for my specific need',         value: 'single'   },
          { label: 'A comprehensive stack for maximum results',              value: 'stack'    }
        ]
      }
    ];

    const recs = {
      recovery: {
        single: {
          name: 'BPC-157', handle: 'bpc-157', badge: 'Tissue Repair',
          why: 'BPC-157 is a prescription-grade peptide that works directly at the site of injury, accelerating the repair of tendons, ligaments, gut lining, and connective tissue at the cellular level. It upregulates VEGFR2 to drive angiogenesis and activates the nitric oxide pathway to reduce localised inflammation — making it the most targeted clinical intervention for injury recovery. Your doctor will determine the appropriate dose and duration based on your specific presentation.'
        },
        stack: {
          name: 'Wolverine Stack', handle: 'wolverine-stack', badge: 'Comprehensive Recovery',
          why: 'The Wolverine Stack combines BPC-157 and TB4 for full-spectrum tissue repair. BPC-157 drives localised cellular repair at the injury site; TB4 works systemically by binding G-actin, mobilising progenitor cells, and reducing pro-inflammatory cytokines across multiple tissue beds simultaneously. Together they produce faster, more complete recovery than either compound alone — this is the most comprehensive recovery protocol available through Clarve.'
        }
      },
      fat: {
        single: {
          name: 'AOD 9604', handle: 'aod-9604', badge: 'Fat Metabolism',
          why: 'AOD 9604 is a synthetic fragment of the C-terminus of human growth hormone that retains its fat-metabolising properties without stimulating IGF-1 or affecting blood sugar. It activates beta-3 adrenergic receptors on adipocytes to drive lipolysis while simultaneously inhibiting fat storage — making it the cleanest, most targeted intervention for stubborn fat, particularly visceral and subcutaneous deposits that resist diet and exercise.'
        },
        stack: {
          name: 'Tesamorelin', handle: 'tesamorelin', badge: 'Body Composition',
          why: 'Tesamorelin is the only FDA-referenced GHRH analogue with proven clinical data on visceral fat reduction. It stimulates endogenous growth hormone production to drive broader metabolic change — improving body composition, increasing lean mass, and reducing visceral adiposity concurrently. Under doctor supervision, it delivers measurable, sustained results that go beyond simple fat loss to reshape overall body composition.'
        }
      },
      immune: {
        single: {
          name: 'Thymosin Alpha-1', handle: 'thymosin-alpha-1', badge: 'Immune Modulation',
          why: 'Thymosin Alpha-1 is the clinical standard for immune modulation and T-cell restoration. Approved for human use in 35+ countries under the name Zadaxin, it drives T-cell maturation in the thymus, activates dendritic cells, amplifies natural killer cell activity, and shifts immune polarisation toward Th1 — restoring competent cell-mediated immunity. It is the most clinically validated peptide for chronic infection, post-viral fatigue, and immune dysregulation.'
        },
        stack: {
          name: 'Thymosin Alpha-1', handle: 'thymosin-alpha-1', badge: 'Immune Modulation',
          why: 'Thymosin Alpha-1 is the clinical standard for immune modulation and T-cell restoration. Approved for human use in 35+ countries, it drives full-spectrum immune restoration — T-cell maturation, NK cell amplification, and dendritic cell activation. For comprehensive immune support, your doctor will design a protocol duration tailored to your immune history, current status, and presenting symptoms, rather than a generic cycle.'
        }
      },
      skin: {
        single: {
          name: 'GHK-Cu', handle: 'ghk-cu', badge: 'Dermal Renewal',
          why: 'GHK-Cu is a copper tripeptide that modulates over 4,000 human genes — upregulating those associated with youthful skin function and downregulating pro-inflammatory and age-related pathways. It directly stimulates collagen types I, III, and IV, activates SOD1 (the body\'s primary antioxidant enzyme), and promotes remodelling of damaged extracellular matrix. If you want a single, precisely targeted skin peptide, GHK-Cu is the most research-backed option available.'
        },
        stack: {
          name: 'Glow Stack', handle: 'glow-stack', badge: 'Full Spectrum Skin',
          why: 'The Glow Stack combines GHK-Cu with complementary skin peptides for full-spectrum collagen remodelling and dermal renewal. Where GHK-Cu drives gene expression and collagen synthesis, the additional peptides in the stack address skin barrier function, elastin production, and pigmentation — producing comprehensive results across texture, tone, fine lines, and elasticity that no single peptide can match alone.'
        }
      },
      muscle: {
        single: {
          name: 'Ipamorelin', handle: 'ipamorelin', badge: 'Lean Muscle',
          why: 'Ipamorelin is a selective growth hormone secretagogue that binds the ghrelin receptor in the pituitary, triggering a clean, controlled GH pulse without elevating cortisol, prolactin, or ACTH. The resulting GH and IGF-1 increase drives lean muscle protein synthesis, accelerates recovery between training sessions, and preferentially mobilises fat from visceral depots — all without the suppression or side-effect profile of synthetic HGH.'
        },
        stack: {
          name: 'Ipamorelin + CJC-1295', handle: 'ipamorelin-cjc', badge: 'GH Secretagogue Stack',
          why: 'Combining Ipamorelin with CJC-1295 (No DAC) amplifies and extends the GH pulse. Ipamorelin triggers the pulse at the GHSR-1a receptor; CJC-1295 acts simultaneously at the GHRH receptor to sustain and deepen it. The result is significantly higher net GH output per dose, driving greater lean mass development, faster recovery, and more consistent fat oxidation — the most effective prescription approach to performance-driven body composition.'
        }
      }
    };

    var answers  = {};
    var current  = 0;

    function setProgress(step) {
      // step -1 = gate screen (0%), 0..n-1 = questions, n = result (100%)
      var total = questions.length;
      var pct   = step < 0 ? 0 : (step / total) * 100;
      if (progressFill)  progressFill.style.width = pct + '%';
      if (progressLabel) {
        if (step < 0)            progressLabel.textContent = 'Step 1 of 4 — Your details';
        else if (step < total)   progressLabel.textContent = 'Step ' + (step + 2) + ' of 4 — Question ' + (step + 1) + ' of 3';
        else                     progressLabel.textContent = 'Your recommendation';
      }
    }

    function renderGate() {
      setProgress(-1);
      quizStage.innerHTML =
        '<div class="quiz-q-text">Tell us who you are before we begin.</div>' +
        '<div class="quiz-gate-form">' +
          '<div class="quiz-field">' +
            '<label class="quiz-field-label" for="quiz-name">Your name</label>' +
            '<input type="text"  class="quiz-field-input" id="quiz-name"  placeholder="First name" autocomplete="given-name">' +
          '</div>' +
          '<div class="quiz-field">' +
            '<label class="quiz-field-label" for="quiz-email">Email address</label>' +
            '<input type="email" class="quiz-field-input" id="quiz-email" placeholder="your@email.com" autocomplete="email">' +
          '</div>' +
          '<div class="quiz-field-error" id="quiz-gate-error"></div>' +
          '<button class="btn-primary" id="quiz-gate-submit" style="width:100%;margin-top:8px;">Start the quiz \u2192</button>' +
          '<div class="quiz-gate-note">We will send your personalised recommendation to this address. Unsubscribe any time.</div>' +
        '</div>';

      var submitBtn = document.getElementById('quiz-gate-submit');
      var errorEl   = document.getElementById('quiz-gate-error');

      function attemptSubmit() {
        var name  = (document.getElementById('quiz-name').value  || '').trim();
        var email = (document.getElementById('quiz-email').value || '').trim();
        errorEl.textContent = '';
        if (!name)  { errorEl.textContent = 'Please enter your name.'; return; }
        if (!email || !email.includes('@')) { errorEl.textContent = 'Please enter a valid email address.'; return; }

        answers.name  = name;
        answers.email = email;
        submitBtn.textContent = 'Saving\u2026';
        submitBtn.disabled    = true;

        // Use the hidden Shopify form — it carries the authenticity token automatically
        var hiddenForm = document.getElementById('quiz-hidden-form');
        var fd;
        if (hiddenForm) {
          document.getElementById('quiz-hidden-email').value = email;
          document.getElementById('quiz-hidden-first').value = name.split(' ')[0];
          document.getElementById('quiz-hidden-last').value  = name.split(' ').slice(1).join(' ');
          fd = new FormData(hiddenForm);
        } else {
          fd = new FormData();
          fd.append('form_type', 'newsletter');
          fd.append('utf8', '\u2713');
          fd.append('email', email);
          fd.append('contact[first_name]', name.split(' ')[0]);
        }

        fetch('/contact', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
          .catch(function() {})   // proceed regardless — don't block the quiz
          .then(function() { renderQuestion(0); });
      }

      submitBtn.addEventListener('click', attemptSubmit);
      ['quiz-name', 'quiz-email'].forEach(function(id) {
        var el = document.getElementById(id);
        if (el) el.addEventListener('keydown', function(e) { if (e.key === 'Enter') attemptSubmit(); });
      });
    }

    function renderQuestion(idx) {
      setProgress(idx);
      var q = questions[idx];
      var html = '<div class="quiz-q-text">' + q.q + '</div><div class="quiz-answers">';
      q.answers.forEach(function(a) {
        html += '<button class="quiz-answer-btn" data-value="' + a.value + '">' + a.label + '</button>';
      });
      html += '</div>';
      quizStage.innerHTML = html;
      quizStage.querySelectorAll('.quiz-answer-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          answers[q.key] = this.dataset.value;
          if (idx < questions.length - 1) {
            renderQuestion(idx + 1);
          } else {
            showResult();
          }
        });
      });
    }

    var goalLabels = {
      recovery: 'Recover from injury or chronic pain',
      fat:      'Lose stubborn fat and improve body composition',
      immune:   'Strengthen or restore immune system',
      skin:     'Improve skin, reduce ageing, rebuild collagen',
      muscle:   'Build lean muscle and improve performance'
    };
    var situationLabels = {
      acute:    'Recent — want to address it now',
      chronic:  'Ongoing for months',
      optimise: 'Generally well, looking to optimise'
    };
    var approachLabels = {
      single: 'Single targeted therapy',
      stack:  'Comprehensive stack'
    };

    var personalIntros = {
      recovery: {
        acute: {
          single: 'You have a recent injury and want a targeted, fast-acting intervention. That is the exact use case BPC-157 was designed for.',
          stack:  'You have a recent injury and want the most comprehensive recovery response possible. That points directly to stacking BPC-157 with TB4.'
        },
        chronic: {
          single: 'Your recovery has stalled or been incomplete for months — a targeted peptide intervention with BPC-157 can restart the cellular repair process your body has stopped prioritising.',
          stack:  'Months of incomplete recovery suggests your body needs more than localised repair. The Wolverine Stack addresses the injury site and the systemic environment simultaneously.'
        },
        optimise: {
          single: 'You are in good health but want to maintain and protect tissue integrity proactively. BPC-157 supports gut lining, connective tissue, and joint health even in the absence of acute injury.',
          stack:  'You want proactive, full-spectrum tissue maintenance. The Wolverine Stack gives you both localised repair support and systemic tissue resilience — the most comprehensive preventive approach available.'
        }
      },
      fat: {
        acute: {
          single: 'You want to start cutting stubborn fat now, cleanly and without hormonal disruption. AOD 9604 is the most targeted option — no IGF-1 effect, no blood sugar interference.',
          stack:  'You want fast, comprehensive body composition change. Tesamorelin drives both visceral fat reduction and metabolic improvement, with clinical data to back it.'
        },
        chronic: {
          single: 'Stubborn fat that has not responded to diet or exercise is often a metabolic issue, not a discipline one. AOD 9604 targets the adipocyte directly and bypasses the metabolic resistance that blocks conventional approaches.',
          stack:  'Persistent fat that resists conventional methods calls for a systemic metabolic intervention. Tesamorelin works at the growth hormone axis to reset your body composition trajectory, not just stimulate lipolysis.'
        },
        optimise: {
          single: 'You are already lean but want to sharpen your composition further. AOD 9604 refines fat distribution without touching IGF-1 or disrupting the hormonal environment you have built.',
          stack:  'For optimising an already healthy body, Tesamorelin delivers the most measurable, clinically documented improvement in body composition — particularly for visceral fat and lean mass ratio.'
        }
      },
      immune: {
        acute: {
          single: 'You are dealing with an acute immune challenge and need rapid restoration of T-cell function. Thymosin Alpha-1 is the most clinically validated peptide for exactly this — with human data across viral illness and immunodeficiency.',
          stack:  'For an acute immune challenge, Thymosin Alpha-1 is the priority intervention. Your doctor will design the protocol intensity to match the urgency of your presentation.'
        },
        chronic: {
          single: 'Chronic immune suppression, post-viral fatigue, or persistent susceptibility to infection — Thymosin Alpha-1 addresses the root cause by restoring the T-cell populations that should be defending you.',
          stack:  'Chronic immune dysfunction requires a sustained protocol, not a short course. Thymosin Alpha-1 under a doctor\'s supervision allows for protocol length and dose to be adjusted as your immune markers improve.'
        },
        optimise: {
          single: 'You want to maintain strong immune resilience as you age. T-cell populations decline naturally from the age of 40. Thymosin Alpha-1 replenishes what time removes — a legitimate longevity intervention with a 35-country clinical track record.',
          stack:  'Immune optimisation is one of the most underutilised aspects of peptide therapy. Thymosin Alpha-1 offers the deepest evidence base for long-term immune maintenance — your doctor will structure the protocol to fit an ongoing wellness plan.'
        }
      },
      skin: {
        acute: {
          single: 'You want results you can see. GHK-Cu works at the gene expression level to activate collagen synthesis and reverse dermal decline — with double-blind RCT data showing measurable improvement in 12 weeks.',
          stack:  'For visible skin improvement across multiple dimensions at once, the Glow Stack is the right choice. It addresses texture, tone, fine lines, and elasticity in parallel rather than sequentially.'
        },
        chronic: {
          single: 'Long-term dermal ageing requires a sustained gene-level intervention. GHK-Cu does not just mask fine lines — it modulates 4,000+ genes to restore the cellular environment of younger skin.',
          stack:  'Chronic skin decline across multiple dimensions — lines, laxity, texture, tone — calls for a full-stack approach. The Glow Stack combines GHK-Cu with complementary peptides to address all of these simultaneously.'
        },
        optimise: {
          single: 'You are proactively protecting your skin before decline accelerates. GHK-Cu is the most evidence-backed preventive peptide for long-term dermal maintenance.',
          stack:  'Proactive skin optimisation benefits most from the broadest intervention. The Glow Stack ensures every dimension of skin health is addressed — not just the most visible one.'
        }
      },
      muscle: {
        acute: {
          single: 'You want to start building lean mass and recovering faster now. Ipamorelin delivers a clean GH pulse nightly — safe, selective, and effective from the first cycle.',
          stack:  'For fast, measurable body composition change, the Ipamorelin and CJC-1295 stack amplifies and sustains the GH pulse beyond what either compound produces alone.'
        },
        chronic: {
          single: 'A plateau in muscle development or recovery often reflects declining GH output. Ipamorelin restores the physiological GH pulse that drives protein synthesis and recovery.',
          stack:  'A persistent performance plateau calls for a sustained GH intervention. Ipamorelin combined with CJC-1295 produces the highest net GH output and the most consistent IGF-1 elevation — the combination that drives real progress past a plateau.'
        },
        optimise: {
          single: 'You are already performing well and want to maintain or sharpen your edge. Ipamorelin supports lean mass, recovery quality, and sleep architecture without disrupting your hormonal baseline.',
          stack:  'High-performance optimisation benefits most from the Ipamorelin and CJC-1295 stack. It sustains elevated GH and IGF-1 across the full training cycle, producing compounding gains in lean mass and recovery efficiency.'
        }
      }
    };

    function showResult() {
      var goal      = answers.goal      || 'recovery';
      var situation = answers.situation || 'acute';
      var approach  = answers.approach  === 'stack' ? 'stack' : 'single';
      var rec       = (recs[goal] && recs[goal][approach]) ? recs[goal][approach] : recs.recovery.single;
      var intro     = personalIntros[goal] && personalIntros[goal][situation] && personalIntros[goal][situation][approach]
                      ? personalIntros[goal][situation][approach]
                      : '';
      setProgress(questions.length);

      var answerSummary =
        '<div class="quiz-answer-summary">' +
          '<div class="quiz-answer-tag">' + (goalLabels[goal]            || '') + '</div>' +
          '<div class="quiz-answer-tag">' + (situationLabels[situation]  || '') + '</div>' +
          '<div class="quiz-answer-tag">' + (approachLabels[approach]    || '') + '</div>' +
        '</div>';

      var firstName = answers.name ? answers.name.split(' ')[0] : '';
      var resultLabel = firstName
        ? firstName + ', here is your recommended therapy'
        : 'Your recommended therapy';

      quizStage.innerHTML =
        answerSummary +
        '<div class="quiz-result-label">' + resultLabel + '</div>' +
        '<div class="quiz-result-name">'  + rec.name  + '</div>' +
        '<div class="quiz-result-badge">' + rec.badge + '</div>' +
        (intro ? '<div class="quiz-result-intro">' + intro + '</div>' : '') +
        '<div class="quiz-result-why">'   + rec.why   + '</div>' +
        '<div class="quiz-result-actions">' +
          '<a href="/products/' + rec.handle + '" class="btn-primary">View ' + rec.name + ' \u2192</a>' +
          '<button class="btn-ghost quiz-restart-btn" style="font-size:11px;">Start over</button>' +
        '</div>';

      quizStage.querySelector('.quiz-restart-btn').addEventListener('click', function() {
        answers = {};
        renderGate();
      });
    }

    renderGate();
  }

  // ── TESTIMONIALS ROTATOR ───────────────────────────────────
  document.querySelectorAll('[data-testimonials-rotator]').forEach(function (rotator) {
    var slides = rotator.querySelectorAll('.testimonials__slide');
    if (slides.length < 2) return;
    var dots = rotator.querySelectorAll('[data-rotator-dots] .testimonials__dot');
    var prevBtn = rotator.querySelector('[data-rotator-prev]');
    var nextBtn = rotator.querySelector('[data-rotator-next]');
    var interval = parseInt(rotator.getAttribute('data-interval'), 10) || 4000;
    var pauseOnHover = rotator.getAttribute('data-pause-on-hover') === 'true';
    var current = 0;
    var timer = null;

    function show(idx) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function start() { stop(); timer = setInterval(function () { show(current + 1); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); start(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-dot-index'), 10));
        start();
      });
    });

    if (pauseOnHover) {
      rotator.addEventListener('mouseenter', stop);
      rotator.addEventListener('mouseleave', start);
    }

    start();
  });

});
